import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class ProjectService {
    constructor(http) {
        this.http = http;
        this.singular = 'project';
        this.plural = 'projects';
        this.editor = PLATFORM.moduleName('pages/quote-setup/projects/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`projects/filter/${loadOptions}`);
        return await response.json();
    }

    async create(project) {
        await this.http.fetch('projects', { method: 'POST', body: json(project) });
    }

    async update(project) {
        await this.http.fetch(`projects/${project.id}`, { method: 'PUT', body: json(project) });
    }

    async delete(id) {
        await this.http.fetch(`projects/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`projects/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`projects/top-three/${query}`);
        return await response.json();
    }
}